<template>
  <div>
    <!-- 옵션 템플릿 선택 -->
    <admin-form-item label="옵션 템플릿 선택" tip="상품의 옵션들을 등록합니다. 옵션가는 상품의 판매가 기준 추가 또는 더할 옵션별 금액이 있는 경우 입력합니다.">
          <span class="select">
            <select @change="selectSelectorTemplate" ref="select_template">
               <option value="" disabled selected>옵션 템플릿 선택</option>
               <option v-for="option in optionTemplateArr"
                       :value="option.value">{{ option.label }}</option>
            </select>
          </span>
    </admin-form-item>

    <div style="max-height:calc(80vh - 180px);padding: 0 12px 12px 0;overflow-y:auto">
      <!-- 선택된 옵션 리스트 -->
      <ul style="list-style:none">
        <li v-for="(item,idx) in tableItems" :key="'prop-opt-item-'+idx">
          <!-- 박스 -->
          <div class="lp-option-item">
            <div class="columns is-multiline">
              <!-- 셀렉터 내용 -->
              <div class="column is-7">
                <admin-form-item label="옵션명*">
                  <input class="input"
                         :value="item.name"
                         @input="e => item.name = e.target.value"
                         type="text" maxlength="30">
                </admin-form-item>
              </div>
              <div class="column is-5">
                <div class="flex btn-group-justify-end">
                  <button class="button half is-danger" @click="delSelector(tableItems, idx)">삭제</button>
                </div>
              </div>

              <div class="column is-full">
                <admin-form-item label="옵션 종류">
                  <lp-radio @onSelect="res => setOptionType(res.value, idx)"
                            value_name="value"
                            label_name="label"
                            :val.sync="item.option_type"
                            :data="optionType"
                            :block="true"></lp-radio>
                </admin-form-item>
              </div>

              <div class="column is-full">
                <admin-form-item label="기본 옵션 설정 여부" :isHeaderBlock="true"
                                 desc="기본 옵션으로 사용할 경우 옵션 템플릿에 저장되며, 신규 상품 등록 시, 이 템플릿이 기본으로 지정됩니다.">
                  <div class="flex align-center" style="margin-top:12px">
                    <lp-check-bool :checked-val.sync="item.selected"
                                   label="이 옵션을 기본 옵션으로 설정합니다."></lp-check-bool>
                  </div>
                </admin-form-item>
              </div>

              <!-- 옵션 내용 -->
              <div class="column is-full has-text-right">
                <button class="button is-grey" @click="addOptionValue(idx)">선택값 추가</button>
              </div>

              <div class="column is-full">
                <draggable v-model="item.options">
                  <div style="padding:0;position: relative;border:1px solid #999;border-radius:4px;margin-bottom:8px"
                       class="columns is-multiline"
                       v-for="(option,idx) in item.options" :key="'prod-option-'+idx">

                    <div class="btn-group-justify-end">
                      <i class="material-icons close-option unselect"
                         style="font-size:24px;margin:12px"
                         @click="deleteOptionValue(item.options, idx)">close</i>
                    </div>

                    <div class="column is-6">
                      <admin-form-item label="옵션명">
                        <input class="input"
                               v-model="option.name"
                               type="text" maxlength="50">
                      </admin-form-item>
                    </div>
                    <div class="column is-5">
                      <admin-form-item label="옵션 가격">
                        <div class="flex">
                          <input class="input"
                                 v-model="option.price"
                                 type="number" maxlength="20">
                          <div class="flex space-between align-center">
                            <div style="margin-left:3px">원</div>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>

                    <div class="column is-12">
                      <admin-form-item label="grade" style="margin-bottom:16px"
                                       tip="플랜변경시 업그레이드,다운그레이드할때 사용함"
                                       v-if="item.option_type===0">
                        <input class="input"
                               style="width:100px"
                               v-model="option.grade"
                               type="number">
                      </admin-form-item>
                      <admin-form-item label="결제 방식">
                        <lp-radio :val.sync="option.is_subscription"
                                  value_name="value"
                                  label_name="label"
                                  :data="[{label:'건 결제', value:false}, {label:'정기 결제',value:true}]"></lp-radio>
                        <div class="desc" v-if="option.is_subscription">* 판매가격으로 월단위 정기 결제됩니다.</div>
                        <div v-if="option.is_subscription" style="padding:16px 0 24px 0">
                          <button class="button is-primary" @click="clickAddSubscription(option)">결제 주기 추가</button>
                          <div class="flex-align" v-for="(item,idx) in option.subscriptions" :key="'subscription-'+idx"
                               style="margin-top:8px">
                            <div style="margin-right:4px">주기</div>
                            <input type="number" v-model="item.date_unit" style="width:40px">
                            <!--<div style="margin:0 4px 0 20px">월별 금액</div>
                            <input type="number" v-model="item.price"><div style="margin-left:4px">원</div>-->

                            <div style="margin-left:20px">
                              <lp-radio :val.sync="item.discount_type"
                                        value_name="value"
                                        label_name="label"
                                        :showInput="true"
                                        :block="true"
                                        @onSelect="res=> setSubscriptionValue(res, item, option)"
                                        @onEdit="res => setSubscriptionValue(res, item, option)"
                                        :data="[{label:'할인율', value:0, num: item.discount_rate, unit:'%'},
                                    {label:'할인액', value:1, num: item.price, unit:'원'}]"></lp-radio>
                            </div>
                            <i class="material-icons unselect" @click="clickDeleteSubs(option, idx)"
                               style="padding:2px;font-size:16px;margin-left:4px">close</i>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>

                    <div class="column is-12">
                      <admin-form-item label="옵션 설명">
                        <textarea class="textarea"
                                  rows="4"
                                  cols="4"
                                  v-model="option.desc"></textarea>
                      </admin-form-item>
                    </div>

                    <div class="column is-6">
                      <admin-form-item label="체크항목">
                        <button class="button" style="width:60px" @click="addCheckItem(option)">+ 추가</button>
                        <div class="choice-items">
                          <div v-for="(item,optIdx) in option.check_items" :key="`check-item-${optIdx}`">
                            <div class="flex-align" style="gap:4px;margin-top:8px">
                              <input type="text" class="input" :value="item"
                                     @input="e => option.check_items[optIdx] = e.target.value">
                              <i class="material-icons unselect" @click="delCheckItem(option.check_items, optIdx)">close</i>
                            </div>
                          </div>
                        </div>
                      </admin-form-item>
                    </div>
                    <div class="column is-6">
                      <admin-form-item label="소스 파일">
                        <input-file  acceptExt=".zip" description="압축파일(zip)만 가능합니다."
                                     :value.sync="option.files"
                                     :maxLength="1"></input-file>
                      </admin-form-item>
                    </div>

                    <div class="column is-12">
                      <admin-form-item label="할인 사용 여부">
                        <lp-radio :val.sync="option.is_discount"
                                  value_name="value"
                                  label_name="label"
                                  :data="[{label:'사용',value:true}, {label:'미사용', value:false}]"></lp-radio>
                      </admin-form-item>
                    </div>
                    <div class="column is-12" v-if="option.is_discount">
                      <admin-form-item label="할인율">
                        <input class="input"
                               style="width:100px"
                               :value="option.discount_rate"
                               @input="e => option.discount_rate = parseInt(e.target.value)"
                               placeholder="할인율"
                               type="number">
                      </admin-form-item>
                    </div>

                    <!-- 다운로드 전환 -->
                    <!--<div class="column is-6" v-if="order_conversion_type===8">
                      <admin-form-item label="옵션 설명">
                        <textarea class="textarea"
                                  rows="4"
                                  cols="4"
                                  v-model="option.desc"></textarea>
                      </admin-form-item>
                    </div>
                    <div class="column is-6" v-if="order_conversion_type===8">
                      <admin-form-item label="옵션 파일">
                        <input type="file"
                               @input="onUploadFile($event, option)">
                      </admin-form-item>
                    </div>
                    <div class="column is-6" v-if="order_conversion_type===8">
                      <admin-form-item label="다운로드 기간">
                        <input class="input"
                               :value="option.download_period"
                               @input="e => option.download_period = e.target.value"
                               type="number" maxlength="365">
                      </admin-form-item>
                    </div>
                    <div class="column is-6" v-if="order_conversion_type===8">
                      <admin-form-item label="다운로드 횟수">
                        <input class="input"
                               :value="option.download_count"
                               @input="e => option.download_count = e.target.value"
                               type="number" maxlength="1000000">
                      </admin-form-item>
                    </div>-->
                  </div>
                </draggable>
              </div>
            </div>
          </div>

        </li>
      </ul>
    </div>
    <div class="btn-group-justify-end" style="margin-top:8px;">
      <button class="button is-primary" @click="$emit('closeOption')">확인</button>
    </div>
  </div>
</template>

<script>
  import LpInputText from "../../module/common/LpInputText";
  import LpOptPopup from "../../module/common/LpOptPopup";
  import { SweetModal } from "sweet-modal-vue";
  import LpModal from "../../module/common/LpModal.vue";
  import LpCheckBool from "./LpCheckBool";
  import LpRadio from "./LpRadio";
  import uuidv4 from 'uuid/v4';
  import draggable from 'vuedraggable'
  import InputFile from "./InputFile";

  export default {
    name: 'LaunchpackProdOption',
    props: {
      selectors: {
        type: Array
      },
      is_modify: {
        type: Boolean
      },
      category1: {
        type: [Number, String]
      },
      category2: {
        type: [Number, String]
      },
      category3: {
        type: [Number, String]
      }
    },
    components: {
      InputFile,
      LpRadio,
      LpCheckBool,
      LpInputText,
      LpOptPopup,
      SweetModal,
      LpModal,
      draggable
    },
    created() {
      if(this.selectors) {
        this.tableItems = this.selectors;
      }

      if(this.category1) {
        this.category1_id = this.category1;
      }
      if(this.category2) {
        this.category2_id = this.category2;
      }
      if(this.category3) {
        this.category3_id = this.category3;
      }
      this.getSelectorTemplate();
    },
    data() {
      return {
        category1_id: null,
        category2_id: null,
        category3_id: null,
        // 상품 옵션
        tableItems: [],
        // 상품 옵션 템플릿
        optionTemplateArr: [
          { label: '새 옵션 추가', value: 0 }
        ],
        // 상품 옵션 타입
        optionType: [
          { label: '필수 선택 옵션', value:0, detail:'*상품 주문 시 반드시 선택해야 하는 상품 속성 성격의 옵션입니다.'},
          { label: '추가 옵션', value:1, detail:'*상품 주문 시 추가 주문할 수 있는 성격의 옵션입니다.'}
        ]
      }
    },
    watch: {
      category1 (n) {
        if(n) {
          this.category1_id = n;
        } else {
          this.category1_id = null;
        }
      },
      category2 (n) {
        if(n) {
          this.category2_id = n;
        } else {
          this.category2_id = null;
        }
      },
      category3 (n) {
        if(n) {
          this.category3_id = n;
        } else {
          this.category3_id = null;
        }
      },
      selectors(n) {
        this.tableItems = n;
      },
      modalStatus(n) {
        if(n==='close'){
          for(let i=0; i<this.tableItems.length; i++) {
            let item = this.tableItems[i];
            if(this.$store.getters.modalResponse.id === item.id) {
              removeIndex(this.tableItems,i);
              break;
            }
          }
        }
      }
    },
    methods: {
      addCheckItem(item) {
        if(item.check_items) {
          item.check_items.push('');
        } else {
         item.check_items = [''];
        }
        this.$forceUpdate();
      },
      delCheckItem(arr, idx) {
       removeIndex(arr, idx);
        this.$forceUpdate();
      },
      setSubscriptionValue(res, item, option) {
        if(res.hasOwnProperty('text')) {
          if(res.value===0) {
            item.discount_rate = parseInt(res.text);
            item.price = option.price - (option.price * item.discount_rate / 100)
          } else {
            item.price = parseInt(res.text);
          }
        } else {
          if(res===0) {
            item.price = option.price - (option.price * item.discount_rate / 100);
          }
        }
      },
      clickDeleteSubs(option,idx) {
        removeIndex(option.subscriptions, idx);
      },
      clickAddSubscription(option) {
        let opt = {
          date_unit: 3,
          price: 0
        }
        if(option.subscriptions) {
          option.subscriptions.push(opt)
        } else {
          option.subscriptions = [opt]
        }
      },
      deleteOptionValue(options, index){
        // console.log('options', options[index])
        let option = options[index];
        if(options.length===1) {
          this.toast('옵션값은 1개 이상이어야합니다.');
          return;
        }
        if(option.id>0) {
          let url = this.getUrl(`product/selector/option/${option.id}`);
          this.$store.commit('setLoading', true);
          this.$axios.delete(url).then(res => {
            if(res.status===200) {
              this.toast('삭제 되었습니다.');
              this.$store.commit('setLoading', false);
              removeIndex(options, index);
            }
          }).catch(() => {
            this.$store.commit('setLoading', false);
            this.toast('서버에 오류가 있습니다.');
          })
        }
        else {
          removeIndex(options, index);
        }
      },
      // 옵션값 추가
      addOptionValue(idx){
        this.tableItems[idx].options.push(
          {
            uuid: uuidv4(),
            id:0,
            name: '옵션',
            price: 0,
            add: 0,
            stock: 0,
            files:[],
            download_count: 0,
            download_period: 3,
            desc: '',
            enable_stock: false,
            is_subscription: false,
            subscriptions: [],
            grade: 0,
            check_items: []
          }
        );
      },

      // 셀렉터 템플릿 가져오기
      getSelectorTemplate(){

        this.$axios.get(this.getUrl('product/selector')).then(res=>{
          let template_selectors = this.cloneItem(res.data);
          // this.category1,2,3는 상품의 카테고리
          // cat.category1,2,3는 selector의 카테고리
          if(!this.category1_id && !this.category2_id && !this.category3_id)  {

          }
          else {
            let vm = this;
            for (let i = template_selectors.length-1; i>=0; i--) {
              let item = template_selectors[i];
              let is_category = false;
              if (item.categorys && item.categorys.length > 0) {
                is_category = item.categorys.some(cat => {
                  if (cat.category1_id === vm.category1_id && !cat.category2_id) {
                    return true;
                  } else if (cat.category1_id === vm.category1_id &&
                    cat.category2_id === vm.category1_id && !cat.category3_id) {
                    return true;
                  } else {
                    return cat.category1_id === vm.category1_id &&
                      cat.category2_id === vm.category2_id &&
                      cat.category3_id === vm.category3_id
                  }
                })
              } else {
                is_category = true;
              }
              if (!is_category) {
                removeIndex(template_selectors, i);
              }
            }
          }

          // 드롭다운에 넣을 옵션템플릿 목록
          let optionTemplateArr = this.optionTemplateArr.concat(template_selectors);
          optionTemplateArr.forEach(selector=>{
            // 기본 추가 옵션 제
            if(selector.value>0) {
              selector.options.forEach(option => {
                option.stock = 0;
                option.add = 0;
                option.enable_stock=false;
                option.uuid = uuidv4();
              })
            }
          })
          this.optionTemplateArr = optionTemplateArr;

          // 상품 등록시 필수값 체크 되어있는 경우만 기본값으로 추가
          /*if(!this.is_modify) {
            let selectors = this.cloneItem(res.data);
            selectors.forEach(selector=>{
              selector.selector_id = selector.id;
              selector.id = 0;
              selector.stock_using = false;
              selector.minimum = 1;
              selector.maximum = 99;
              if(selector.required){
                selector.options.forEach(option=>{
                  option.id = 0;
                  option.add = 0;
                  option.stock = 0;
                  option.enable_stock=false;
                  option.uuid = uuidv4();
                  option.grade = 0;
                })
                // this.tableItems = [selector];
                // this.tableItems.push(selector);
                let item = find(this.tableItems, 'selector_id', selector.selector_id)
                if(item===undefined) this.tableItems.push(selector);
              }
            })
          }*/
        })
      },
      // 셀렉터 템플릿 선택
      selectSelectorTemplate(e){
        if(parseInt(e.target.value)===0) {
          this.tableItems.push ({
            id:0,
            name:'기본 옵션',
            type:0,
            selected: false,
            required: false,
            option_type: 0,
            stock_using: false,
            minimum: 1,
            maximum: 99,
            options: [
              {
                uuid: uuidv4(),
                id:0,
                name: '옵션',
                price: 0,
                add: 0,
                stock: 0,
                files:[],
                download_count: 0,
                download_period: 3,
                desc: '',
                enable_stock: false,
                grade: 0,
                is_subscription: false,
                subscriptions: []
              }
            ]
          })
        }
        else {
          for(let i=0; i<this.optionTemplateArr.length; i++) {
            if(this.optionTemplateArr[i].id===parseInt(e.target.value)){
              let template = this.cloneItem(this.optionTemplateArr[i]);
              // 상품 옵션 템플릿은 id가 있기 때문에
              // 상품 등록시 옵션 생성후 0으로 초기화후 생성한다
              template.id = 0;
              template.selected=false;
              template.stock_using=false;
              template.minimum = 1;
              template.maximum = 99;
              for(let j=0; j<template.options.length; j++){
                template.options[j].id = 0;
              }

              this.tableItems.push(template);
              break;
            }
          }
        }
        this.$refs.select_template.value = '';
      },
      // 셀렉터 템플릿 수정
      /*modifySelector(item){
        this.$store.commit('openModal', {type: 'modal-product-option', value: value });
      },*/
      // 셀렉터 템플릿 삭제
      delSelector(items, index){
        if (items[index].id) {
          let value = {
            id: items[index].id,
            url: 'product/real/selector/',
            title: '상품 옵션을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
        else {
          removeIndex(this.tableItems, index);
        }
      },
      // 옵션 종류 선택
      setOptionType(res, idx){
        this.selectors[idx].option_type = res;
      },
    }
  };
</script>

<style lang="stylus" type="stylus" scoped>
  @import '~assets/css/lp_main'
  .product-short-input
    width 89px

  .lp-option-item
    font-size 0.9rem
    border 1px solid #999
    border-radius 4px
    margin-top 12px
    padding 4px 0

  .lp-option-item div
    margin auto 0

  .lp-option-item div:last-child
    margin-right 0

  .btn-add-option
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem

  .close-option
    cursor pointer
    font-size 18px
    color #787878

  .close-option:hover
    color #000

  .desc
    margin-top 8px !important
    font-size 0.9rem
    color #989898
</style>
